module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/consultation/consultation.component.scss
// module id = ./src/app/consultation/consultation.component.scss
// module chunks = main